import { Point, point, LineString } from '@turf/helpers';
import { LatLngLiteral } from 'leaflet';
import destination from '@turf/destination';
import bearing from '@turf/bearing';
import distance from '@turf/distance';

export const latLngToPoint = ({ lat, lng }: LatLngLiteral) => {
  const feature = point([lng, lat]);
  return feature.geometry;
};

export const pointToLatLng = (point: Point): LatLngLiteral => ({
  lat: point.coordinates[1],
  lng: point.coordinates[0],
});

export const lineStringToLatLng = ({ coordinates }: LineString) => {
  return {
    type: 'LineString',
    coordinates,
  };
};

export const validateCoordinates = (latitude: number, longitude: number) => {
  return (
    isFinite(latitude) &&
    Math.abs(latitude) <= 90 &&
    isFinite(longitude) &&
    Math.abs(longitude) <= 180
  );
};

export const movePointGeometry = ({
  coordinates: prevCoordinates,
  distance,
  bearing,
}: {
  coordinates?: [number, number];
  distance: number;
  bearing: number;
}) => {
  if (!prevCoordinates) {
    return [0, 0];
  }
  const prevPoint = point(prevCoordinates);
  const newPoint = destination(prevPoint, distance, bearing);
  const { geometry } = newPoint;
  const { coordinates } = geometry;

  return coordinates as [number, number];
};

export const moveLineGeometry = ({
  line,
  distance,
  bearing,
}: {
  line: [number, number][];
  distance: number;
  bearing: number;
}) => {
  return line.map((endpoint) => {
    return movePointGeometry({
      coordinates: endpoint,
      distance,
      bearing,
    });
  });
};

export const getBearingAndDistance = (
  prevCoordinates: [number, number],
  newCoordinates: [number, number]
) => {
  const prevPoint = point(prevCoordinates);
  const newPoint = point(newCoordinates);

  const b = bearing(prevPoint, newPoint);
  const d = distance(prevPoint, newPoint);

  return { bearing: b, distance: d };
};
